import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { DialogOutletService } from './dialog-outlet';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { GetRoutesForQuoteResponsePayload, QuotePageData } from '@cpak/adp-cpak-bff-service-models';
import { OpenRouteModal } from '@cpak/interfaces';
import { QuoteModel, QuoteRoute } from '@cpak/adp-cpak-quotes-service-models';
import { PackInFocusFacade } from '@cpak/main-features-lib/data-store';
import { RouteQuotesFetchService } from './route-quotes-fetch.service';

@Injectable({
  providedIn: 'root',
})
export class RouteQuotesService extends DialogOutletService {
  private creationMode$ = new BehaviorSubject<string>('');
  private isLocked$ = new BehaviorSubject<boolean>(false);
  private quoteData$ = new BehaviorSubject<QuotePageData | null>(null);
  private routingResponseData$ = new Subject<QuoteModel>();
  private currentRoute!: QuoteRoute;
  constructor(
    router: Router,
    private packInFocusFacade: PackInFocusFacade,
    private routeQuotesFetchService: RouteQuotesFetchService
  ) {
    super(router, 'routeQuote');
  }

  public onCloseModalWithData(data: QuoteModel): void {
    super.onCloseModal();
    this.packInFocusFacade.checkQuoteAndClear(data);
    this.routingResponseData$.next(data);
  }

  public openRouteQuoteModal(config: OpenRouteModal): void {
    this.creationMode$.next(config.creationType);
    this.quoteData$.next(config.quoteData || null);
    super.onOpenModal(config.id);
  }
  public getCurrentRoutingHistory(pakId: string): Observable<GetRoutesForQuoteResponsePayload | null> {
    return this.routeQuotesFetchService.getRouteByQuoteId(pakId);
  }
  public getCreationMode(): string {
    return this.creationMode$.getValue();
  }

  public getQuoteData(): QuotePageData | null {
    return this.quoteData$.getValue();
  }

  public setQuoteData(data: QuotePageData | null): void {
    this.quoteData$.next(data);
  }

  public getRoutingData(): Observable<QuoteModel> {
    return this.routingResponseData$.asObservable();
  }

  public getIsLocked(): boolean {
    return this.isLocked$.getValue();
  }

  public clearQuoteData(): void {
    this.quoteData$.next(null);
  }
}
